export const insights = {
    "structure": [
        {
            "view": "welcome",
            "props": {
                "logo_url": "https://global--assets.s3.eu-west-2.amazonaws.com/production/survey-assets/9/welcome_image.png",
                "title": "A Welcome Page Title",
                "subtitle": "A Welcome Page Subtitle",
				"description": "A **Welcome** *Page* Subtitle",
                "client_name": "Client Name",
                "client_email": "privacy@example.com",
                "client_phone": "01234 567890",
                "client_privacy": "https://cavendishconsulting.com/privacy"
            }
        },
        {
            "view": "steps",
            "props": {
                "steps": [
                    {
                        "step": "question",
                        "type": "choice",
                        "title": "Do you feel that a new Aldi food store would be a benefit to the area?",
                        "key": "Do you feel that a new Aldi food store would be a benefit to the area?",
                        "instruction": "Instructions: on choicesssss",
                        "max_answers": 2,
                        "min_answers": 0,
						"other": true,
                        "answers": [
                            {
                                "image_url": null,
                                "label": "Yes",
                                "value": "Yes"
                            },
                            {
                                "image_url": null,
                                "label": "No",
                                "value": "No"
                            },
                            {
                                "image_url": null,
                                "label": "Unsure",
                                "value": "Unsure"
                            }
                        ]
                    },
		            {
						"step": "question",
						"type": "grid",
						"key": "Please tell us how you rate the following aspects of transport infrastructure 2",
						"title": "Please tell us how you rate the following aspects of transport infrastructure 2:",
						"topics": [
							{
								"key": "Reliability",
								"label": "Reliability"
							},
							{
								"key": "Cleanliness",
								"label": "Cleanliness"
							},
							{
								"key": "Connectivity",
								"label": "Connectivity"
							},
							{
								"key": "Price",
								"label": "Price"
							}
						],
						"answers": [
							"Very good",
							"Good",
							"OK",
							"Poor",
							"Very Poor"
						]
					},
                    {
                        "step": "question",
                        "type": "choice",
                        "title": "Do you feel that a new Aldi food store would be a benefit to the area?",
                        "key": "Do you feel that a new Aldi food store would be a benefit to the area?",
                        "instruction": "Instructions: on choicesssss",
                        "max_answers": 2,
                        "min_answers": 0,
						"other": true,
                        "answers": [
                            {
                                "image_url": null,
                                "label": "Yes",
                                "value": "Yes"
                            },
                            {
                                "image_url": null,
                                "label": "No",
                                "value": "No"
                            },
                            {
                                "image_url": null,
                                "label": "Unsure",
                                "value": "Unsure"
                            }
                        ]
                    },
		            {
						"step": "question",
						"type": "grid",
						"key": "Ranking some questions out of 10",
						"title": "Ranking some questions out of 10",
						"topics": [
							{
								"key": "Short Q",
								"label": "Short Q"
							},
							{
								"key": "Long question, Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
								"label": "Long question, Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
							},
							{
								"key": "Another Question about something",
								"label": "Another Question about something"
							},
							{
								"key": "Another Question about something1",
								"label": "Another Question about something1"
							},
							{
								"key": "Another Question about something2",
								"label": "Another Question about somethin2g"
							},
							{
								"key": "Another Question about something3",
								"label": "Another Question about somethin3g"
							},
							{
								"key": "Another Question about something4",
								"label": "Another Question about somethin5g"
							},
							{
								"key": "Another Question about something6",
								"label": "Another Question about somethin6g"
							},
							{
								"key": "Another Question about something7",
								"label": "Another Question about somethin8g"
							},
							{
								"key": "Another Question about something88",
								"label": "Another Question about something88"
							}
						],
						"answers": [
							"1",
							"2",
							"3",
							"4",
							"5",
							"6",
							"7",
							"8",
							"9",
							"10"
						]
					},
                    {
                        "step": "question",
                        "type": "paragraph",
                        "instruction": "Instructions: **on** *paragraph?*\n\n## heading2\n\n<a href=\"https://example.com\">liiiiiink</a>",
                        "title": "What do you think about the proposals????",
                        "key": "What do you think about the proposals?",
                        "max_characters": 100
                    },
                    {
                        "step": "question",
                        "type": "number",
                        "title": "What is your current age?",
                        "key": "What is your current age?",
                        "instruction": "Instructions: on number",
                        "default": 13,
                        "min": 13,
                        "max": 100,
                        "increment": 1
                    },
                    {
                        "step": "info",
                        "type": "content",
                        "title": "Store Details",
                        "image": "https://placehold.co/600x400",
                        "crop": true,
                        "body": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.Curabitur id malesuada nisl.Maecenas justo eros, rhoncus sit amet dui ut, molestie auctor dolor.Integer porta neque nec condimentum vulputate.Aliquam malesuada, purus id sagittis venenatis, eros sem gravida nisi, non consequat est justo nec turpis.Mauris non dapibus urna, at lacinia lorem.Nullam faucibus commodo neque.Integer sagittis felis vel massa mollis, in posuere dui pretium.Etiam lorem eros, pretium et mollis et, commodo ac ex.Quisque mollis faucibus nibh, vitae rhoncus et",
                    },
                    {
                        "step": "info",
                        "type": "gallery",
                        "title": "Car Parking",
                        "description": "The site provides ample car parking space, have a look at the images below to see its facilities in more detail",
                        "images":[
                            {
                                "image": "https://placehold.co/600x400",
                                "caption": "Electric vehicle charging"
							},
                            {
                                "image": "https://placehold.co/600x400",
                                "caption": "Electric vehicle charging 2"
							}
                        ]
                    },
                    {
                        "type": "choice",
                        "title": "What would you like to see on the ground floor commercial space?",
                        "key": "What would you like to see on the ground floor commercial space?",
                        "instruction": "Instructions: on choices",
                        "max_answers": 3,
                        "answers": [
                            {
                                "image_url": null,
                                "label": "Convenience Store",
                                "value": "Convenience Store",
                            },
                            {
                                "image_url": null,
                                "label": "Supermarket",
                                "value": "Supermarket",
                            },
                            {
                                "image_url": null,
                                "label": "Fashion Retailer",
                                "value": "Fashion Retailer",
                            },
                            {
                                "image_url": null,
                                "label": "Fast Food",
                                "value": "Fast Food",
                            },
                            {
                                "image_url": null,
                                "label": "Bars & Nightclubs",
                                "value": "Bars & Nightclubs",
                            },
                        ]
                    },
                    {
                        "type": "order",
                        "title": "Please rank the following in order of importance to you",
                        "key": "Please rank the following in order of importance to you",
                        "instruction": "Drag and drop in the order you'd like",
                        "answers": [
                            {
                                "label": "Parking",
                                "value": "Parking"
                            },
                            {
                                "label": "Library",
                                "value": "Library"
                            },
                            {
                                "label": "Parks",
                                "value": "Parks"
                            },
                            {
                                "label": "Local Shops",
                                "value": "Local Shops"
                            },
                            {
                                "label": "Schools",
                                "value": "Schools"
                            },
                        ]
                    },
		            {
		                "key": "Form",
		                "step": "question",
                        "instruction": "Instructions: on the form",
		                "type": "form",
		                "title": "Form",
		                "fields": [
			                {
			                    "key": "Text",
			                    "type": "text",
			                    "label": "Text",
			                    "personal": false
			                },
			                {
			                    "key": "Number",
			                    "type": "number",
			                    "label": "Number",
			                    "personal": false
			                },
			                {
			                    "key": "Date",
			                    "type": "date",
			                    "label": "Date",
			                    "personal": false
			                },
			                {
			                    "key": "Email",
			                    "type": "email",
			                    "label": "Email",
			                    "personal": false
			                },
			                {
			                    "key": "Phone",
			                    "type": "tel",
			                    "label": "Phone",
			                    "personal": false
			                }
		                ]
					},
                ]
            }
        },
	    {
	        "view": "submit",
	        "props": {
	            "title": "Submit your answers",
	            "statement": "Submit statement.\n\nLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
	            "logo_url": "https://global--assets.s3.eu-west-2.amazonaws.com/production/survey-assets/9/welcome_image.png",
	            "privacy_link": "https:\/\/cavendishconsulting.com\/privacy",
	            "terms_link": "https:\/\/cavendishconsulting.com\/terms",
				"captcha": false,
	            "agreements": [
	            {
	                "label": "I agree to the privacy policy and confirm I'm over 13 years old.",
	                "key": "I agree to the privacy policy and confirm I'm over 13 years old.",
	                "required": true
	            },
	            {
	                "label": "Non required box",
	                "key": "Non required box",
	                "required": false
	            }
	            ]
	        }
	    },
        {
            "view": "thanks",
            "props": {
                "title": "A Thanks Page Title",
                "statement": "A Thanks Page Statement",
                "more_statement": "A Find Out More Statement",
                "more_url": "https://example.com",
				"more_button_text": "Custom Button Text",
                "share": true
            }
        },
    ],
    "actions":{
        data(data){
            console.log("Submitting Data", data);
			return JSON.stringify(data);
        },
        interaction(type, label, target){
            console.log("Interaction", type, label, target)
        },
        progress(status){
            console.log("progress", status)
			return fetch("/actions/data", {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
				},
				method: "POST",
				body: JSON.stringify(status),
			});
        },
    },
	"lang": "en-gb",
	"status": 'Live',
	"progressbar": false,
	"layout": 'Vertical',
}
